import { CreateDemographyRequestBody } from "./request-body"
import { apiBaseUrl }                  from "./config"
import Constant                        from "./constant"
import { getBaseHeader }               from "./utils"
import ApiError, { ApiErrorCode }      from "../../error/api-error"
import { Demography, LocalAuthority }  from "../../model"

export default class DemographiesService {
	private static readonly BASE_URL = `${apiBaseUrl}/${Constant.UrlSegment.LOCAL_AUTHORITIES}`

	static createDemography(
		localAuthority: LocalAuthority,
		demography    : CreateDemographyRequestBody,
		signal?: AbortSignal
	): Promise<Demography> {
		const body = JSON.stringify({ demography: demography })
		const url  = `${DemographiesService.BASE_URL}/${localAuthority.id}/${Constant.UrlSegment.DEMOGRAPHIES}`
		const init = {
			body,
			headers: { ...getBaseHeader(), 'Content-Type': 'application/json' },
			method: "POST",
			signal
		} as RequestInit

		return fetch(url, init).then(response => {
			switch (response.status) {
				case 200:
					return response.json().then(result => result as Demography)
				case 404:
					throw new ApiError(ApiErrorCode.NotFound, "La collectivité locale n'existe pas.")
				case 409:
					throw new ApiError(ApiErrorCode.Conflict, "La démographie existe déjà.")
			}
			throw new Error("Unexpected error.")
		})
	}

	static deleteDemography(
		demography: Demography
	): Promise<void> {
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/service/sfp/demographies-service.ts